"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMyProfileEndpoint = getMyProfileEndpoint;
exports.getChangeContactDetailsEndpoint = getChangeContactDetailsEndpoint;
exports.getAddressDataEndpoint = getAddressDataEndpoint;
exports.getAddressChangeEndpoint = getAddressChangeEndpoint;
exports.getIbanChangeEndpoint = getIbanChangeEndpoint;
function getMyProfileEndpoint() {
    return "/my-profile";
}
function getChangeContactDetailsEndpoint() {
    return `${getMyProfileEndpoint()}/contact-details-change`;
}
function getAddressDataEndpoint() {
    return "/get-address-data";
}
function getAddressChangeEndpoint() {
    return `${getMyProfileEndpoint()}/address-change`;
}
function getIbanChangeEndpoint() {
    return `${getMyProfileEndpoint()}/iban-change`;
}
//# sourceMappingURL=my-profile.js.map